import React, { useContext, useEffect, useState } from 'react'
import { Typography, Box, ListItemText, List, ListItem, ListItemIcon, Switch, IconButton, Radio, RadioGroup, Drawer } from "@mui/material";
import AdsClickOutlinedIcon from '@mui/icons-material/AdsClickOutlined';
import { ThemeContext } from '../../context/ThemeContext';
import { useTranslation } from 'react-i18next';
import OneClickTrading from '../../components/modal/OneClickTrading';
import { HiBars2 } from 'react-icons/hi2';
import SideDrawer from '../components/SidebarMenu';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ChangePin from '../components/setting/ChangePin';
import { HiOutlineFingerPrint } from "react-icons/hi2";
import { IoLanguageOutline } from "react-icons/io5";
import { HiOutlineLockClosed } from "react-icons/hi2";
import { HiOutlineSwatch } from "react-icons/hi2";
import { HiOutlineDevicePhoneMobile } from "react-icons/hi2";
import { HiOutlineClipboardDocumentCheck } from "react-icons/hi2";
import { HiOutlineClipboardDocumentList } from "react-icons/hi2";
import { IoIosHelpCircleOutline } from "react-icons/io";
import { VscClose } from "react-icons/vsc";
import About from './About';


export default function Setting() {
  const { i18n, t } = useTranslation();
  const [isDisclamerOpen, setIsDisclamerOpen] = useState(false);
  const clientId = localStorage.getItem('clientId')
  const [hasAcceptedDisclaimer, setHasAcceptedDisclaimer] = useState(() => {
    const stored = localStorage.getItem(`oneClickTradingAgreement_${clientId}`);
    try {
      const parsed = JSON.parse(stored);
      return parsed?.agreed === true;
    } catch (e) {
      return false;
    }
  });

  const { darkMode } = useContext(ThemeContext)
  const bgImage = '/BG.png'
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [alwaysOnDisplay, setAlwaysOnDisplay] = useState(false);
  const [activePage, setActivePage] = useState(null);
  const { toggleTheme, setDirection } = useContext(ThemeContext)
  const [isBottomDrawerOpen, setBottomDrawerOpen] = useState(false);
  const [drawerType, setDrawerType] = useState(null);
  const [selectedTheme, setSelectedTheme] = useState(darkMode ? 'dark' : 'light');
  const [selectedLang, setSelectedLang] = useState(i18n.language || 'en');

  const handleOpenDisclamer = (event) => {
    const checked = event.target.checked;
    if (checked) {
      if (!hasAcceptedDisclaimer) {
        setIsDisclamerOpen(true);
      } else {
        setHasAcceptedDisclaimer(true);
      }
    } else {
      setHasAcceptedDisclaimer(false);
      localStorage.setItem(`oneClickTradingAgreement_${clientId}`, JSON.stringify({ agreed: false }));
    }
  };


  const handleCloseDisclamer = () => {
    setIsDisclamerOpen(false);
  };
  const handleAcceptDisclaimer = () => {
    setHasAcceptedDisclaimer(true); // Update state when user accepts
  };
  useEffect(() => {
    const savedValue = localStorage.getItem('alwaysOnDisplay');
    if (savedValue !== null) setAlwaysOnDisplay(savedValue === 'true');
  }, []);

  const toggleAlwaysOnDisplay = () => {
    setAlwaysOnDisplay(prev => {
      const newVal = !prev;
      localStorage.setItem('alwaysOnDisplay', newVal);
      return newVal;
    });
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng);
    setDirection(lng === 'ar' ? 'rtl' : 'ltr');
    document.dir = lng === 'ar' ? 'rtl' : 'ltr';
    setActivePage(null)
  };

  const languageOptions = [
    { value: 'en', native: 'English', label: 'english' },
    { value: 'ar', native: 'العربية', label: 'arabic' },
    { value: 'hi', native: 'हिन्दी', label: 'hindi' },
  ];

  const renderMainList = () => (
    <List disablePadding>
      <ListItem sx={{ py: 0.5 }} button onClick={() => setActivePage('changePin')}>
        <ListItemIcon><HiOutlineLockClosed style={{ fontSize: 20, color: darkMode ? "var(--lightText)" : 'var(--black)' }} /></ListItemIcon>
        <ListItemText primaryTypographyProps={{ fontSize: 14, fontWeight: 400, color: darkMode ? "var(--lightText)" : 'var(--black)' }} primary={t("changePin")} />
        <ArrowForwardIosIcon sx={{ fontSize: 14, fontWeight: 400, color: 'lightgray' }} />
      </ListItem>

      <ListItem sx={{ py: 0.5 }} button onClick={() => { setDrawerType("language"); setBottomDrawerOpen(true); }}>
        <ListItemIcon><IoLanguageOutline style={{ fontSize: 20, color: darkMode ? "var(--lightText)" : 'var(--black)' }} /></ListItemIcon>
        <ListItemText primaryTypographyProps={{ fontSize: 14, fontWeight: 400, color: darkMode ? "var(--lightText)" : 'var(--black)' }} primary={t("changeLanguage")} />
        <ArrowForwardIosIcon sx={{ fontSize: 14, fontWeight: 400, color: 'lightgray' }} />
      </ListItem>

      {/* <ListItem sx={{ py: 0.5 }}>
        <ListItemIcon><HiOutlineFingerPrint style={{ fontSize: 20, color: darkMode ? "var(--lightText)" : 'var(--black)' }} /></ListItemIcon>
        <ListItemText primary={t("touchId")} primaryTypographyProps={{ fontSize: 14, fontWeight: 400, color: darkMode ? "var(--lightText)" : 'var(--black)' }} />
        <Switch checked={true} onChange={false} />
      </ListItem> */}
    </List>
  );


  return (
    <>
      {!activePage && (
        <>
          <Box sx={{ height: '100vh', overflow: 'hidden', backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center', display: 'flex', flexDirection: 'column', }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, }}>
              <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 0.5 }}>
                <HiBars2 onClick={() => setDrawerOpen(true)} style={{ fontSize: 24, color: 'white' }} />
                <Typography color='white' variant='body1' sx={{ fontSize: 18 }}> {t('setting')}</Typography>
              </Box>
            </Box>

            <Box sx={{ flexGrow: 1, overflowY: 'auto', pb: 10, backgroundColor: darkMode ? "#151924" : "var(--white)", }}>
              <Typography px={2} py={1} fontSize={15} color={darkMode ? 'white' : 'black'}>{t('security')}</Typography>
              <Box>{renderMainList()}</Box>

              <Typography px={2} py={1} fontSize={15} color={darkMode ? 'white' : 'black'}>{t('preferences')}</Typography>
              <List disablePadding sx={{ pt: 0, pb: 0 }}>
                <ListItem sx={{ py: 0.5 }} button onClick={() => { setDrawerType("theme"); setBottomDrawerOpen(true); }}>
                  <ListItemIcon><HiOutlineSwatch style={{ fontSize: 20, color: darkMode ? "var(--lightText)" : 'var(--black)' }} /></ListItemIcon>
                  <ListItemText primaryTypographyProps={{ fontSize: 14, fontWeight: 400, color: darkMode ? "var(--lightText)" : 'var(--black)' }} secondaryTypographyProps={{ fontSize: 12, color: darkMode ? "var(--lightText)" : 'var(--black)' }} primary={t("appTheme")} secondary={darkMode ? t('darkTheme') : t('lightTheme')} />
                  <ArrowForwardIosIcon sx={{ fontSize: 14, fontWeight: 400, color: 'lightgray' }} />
                </ListItem>
                {/* <ListItem sx={{ py: 0.5 }}>
                  <ListItemIcon><HiOutlineDevicePhoneMobile style={{ fontSize: 20, color: darkMode ? "var(--lightText)" : 'var(--black)' }} /></ListItemIcon>
                  <ListItemText primaryTypographyProps={{ fontSize: 14, fontWeight: 400, color: darkMode ? "var(--lightText)" : 'var(--black)' }} primary={t("alwaysOnDisplay")} />
                  <Switch checked={alwaysOnDisplay} onChange={toggleAlwaysOnDisplay} />
                </ListItem> */}
                <ListItem sx={{ py: 0.5 }}>
                  <ListItemIcon><AdsClickOutlinedIcon style={{ fontSize: 20, color: darkMode ? "var(--lightText)" : 'var(--black)' }} /></ListItemIcon>
                  <ListItemText primaryTypographyProps={{ fontSize: 14, fontWeight: 400, color: darkMode ? "var(--lightText)" : 'var(--black)' }} primary={t("oneClickTrading")} />
                  <Switch checked={hasAcceptedDisclaimer} onChange={handleOpenDisclamer} />
                </ListItem>
              </List>

              <List disablePadding sx={{ pb: 0, pt: 0 }}>
                <ListItem sx={{ py: 0.5 }} button onClick={() => window.open(process.env.REACT_APP_TERMS_OF_SERVICE_URL, '_blank')}>
                  <ListItemIcon><HiOutlineClipboardDocumentCheck style={{ fontSize: 20, color: darkMode ? "var(--lightText)" : 'var(--black)' }} /></ListItemIcon>
                  <ListItemText primaryTypographyProps={{ fontSize: 14, fontWeight: 400, color: darkMode ? "var(--lightText)" : 'var(--black)' }} primary={t("termcondition")} />
                  <ArrowForwardIosIcon sx={{ fontSize: 14, fontWeight: 400, color: 'lightgray' }} />
                </ListItem>
                <ListItem sx={{ py: 0.5 }} button onClick={() => window.open(process.env.REACT_APP_HELP_PAGE_URL, '_blank')}>
                  <ListItemIcon><IoIosHelpCircleOutline style={{ fontSize: 20, color: darkMode ? "var(--lightText)" : 'var(--black)' }} /></ListItemIcon>
                  <ListItemText primaryTypographyProps={{ fontSize: 14, fontWeight: 400, color: darkMode ? "var(--lightText)" : 'var(--black)' }} primary={t("help")} />
                  <ArrowForwardIosIcon sx={{ fontSize: 14, fontWeight: 400, color: 'lightgray' }} />
                </ListItem>
                <ListItem sx={{ py: 0.5 }} button onClick={() => window.open(process.env.REACT_APP_PRIVACY_POLICY_URL, '_blank')}>
                  <ListItemIcon><HiOutlineClipboardDocumentList style={{ fontSize: 20, color: darkMode ? "var(--lightText)" : 'var(--black)' }} /></ListItemIcon>
                  <ListItemText primaryTypographyProps={{ fontSize: 14, fontWeight: 400, color: darkMode ? "var(--lightText)" : 'var(--black)' }} primary={t("privacyPolicy")} />
                  <ArrowForwardIosIcon sx={{ fontSize: 14, fontWeight: 400, color: 'lightgray' }} />
                </ListItem>

                <ListItem sx={{ py: 0.5 }} button onClick={() => setActivePage('about')}>
                  <ListItemIcon><InfoOutlinedIcon style={{ fontSize: 20, color: darkMode ? "var(--lightText)" : 'var(--black)' }} /></ListItemIcon>
                  <ListItemText primaryTypographyProps={{ fontSize: 14, fontWeight: 400, color: darkMode ? "var(--lightText)" : 'var(--black)' }} primary={t("about")} />
                  <ArrowForwardIosIcon sx={{ fontSize: 14, fontWeight: 400, color: 'lightgray' }} />
                </ListItem>
              </List>
            </Box>
            <Drawer anchor="bottom" open={isBottomDrawerOpen} onClose={() => setBottomDrawerOpen(false)} PaperProps={{ sx: { borderRadius: '12px 12px 0 0', px: 2, py: 2 } }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="subtitle1" fontWeight={600}>
                  {drawerType === 'theme' ? t('selectTheme') : t('selectLanguage')}
                </Typography>
                <IconButton onClick={() => setBottomDrawerOpen(false)}><VscClose /></IconButton>
              </Box>

              <RadioGroup value={drawerType === 'theme' ? selectedTheme : selectedLang}
                onChange={(e) => {
                  const value = e.target.value;
                  if (drawerType === 'theme') {
                    setSelectedTheme(value);
                    toggleTheme();
                  } else {
                    setSelectedLang(value);
                    changeLanguage(value);
                  }
                  setBottomDrawerOpen(false);
                }}
              >
                {(drawerType === 'theme'
                  ? [{ value: 'light', label: t('lightTheme') }]
                  : languageOptions.map((option) => ({ ...option, label: `${t(option.label)} (${option.native})`, }))
                ).map((option) => (
                  <Box key={option.value} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                    <Typography>{option.label}</Typography>
                    <Radio value={option.value} checked={drawerType === 'theme' ? selectedTheme === option.value : selectedLang === option.value} />
                  </Box>
                ))}
              </RadioGroup>
            </Drawer>

            <SideDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
            {isDisclamerOpen && <OneClickTrading isOpen={isDisclamerOpen} onClose={handleCloseDisclamer} onAccept={handleAcceptDisclaimer} />}
          </Box>
        </>
      )}
      {activePage === 'changePin' && <ChangePin setActivePage={setActivePage} />}
      {activePage === 'about' && <About />}

    </>)
}